export const MaterialColors = ["#2196f3", "#FFDE03", "#48b174", "#bc5038", "#000000", "#e876fe", "#4ed7fe", "#fe9700", "#00feda", "#b4b4b4", "#8d492d", "#357951", "#79006e"]
